/**
 * ステップフロー本文の切替アニメーション（framer-motion の props としてスプレッドする）。
 * 入力 / 確認は横スライド、完了は少し拡大しながらフェードイン。
 */
export const stepTransition = {
  initial: { opacity: 0, x: 20 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -20 },
  transition: { duration: 0.3 },
} as const;

export const completeTransition = {
  initial: { opacity: 0, scale: 0.9 },
  animate: { opacity: 1, scale: 1 },
  transition: { duration: 0.5 },
} as const;
